import { create } from "zustand";

interface QuickPostModalState {
  isDirty: boolean;
  isFullscreen: boolean;
  isSubmitting: boolean;
  setIsDirty: (isDirty: boolean) => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  toggleFullscreen: () => void;
}

export const useQuickPostModalStore = create<QuickPostModalState>(set => ({
  isFullscreen: false,
  toggleFullscreen: () => set(state => ({ isFullscreen: !state.isFullscreen })),
  isSubmitting: false,
  setIsSubmitting: (isSubmitting: boolean) => set({ isSubmitting }),
  isDirty: false,
  setIsDirty: (isDirty: boolean) => set({ isDirty }),
}));
